import { styled } from '@mui/material/styles'
import { Switch } from '@mui/material'

const StyledSwitch = styled(Switch)(() => ({
    width: 52,
    height: 28,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 4,
        '&.Mui-checked': {
            transform: 'translateX(24px)',
            color: '#ffffff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'var(--forbrand-color)',
                opacity: 1,
                border: 'none',
            },
        },
        '&:not(.Mui-checked) + .MuiSwitch-track': {
            backgroundColor: '#e0e0e0',
            opacity: 1,
        },
    },
    '& .MuiSwitch-thumb': {
        width: 20,
        height: 20,
        borderRadius: 0,
        backgroundColor: '#ffffff',
        boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
        borderRadius: 0,
        backgroundColor: '#e0e0e0',
        opacity: 1,
    },
}))

export default StyledSwitch
